import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
}), 'FormatAlignLeft');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatAlignLeft.js
// module id = 3804
// module chunks = 2